import { TRUSTED_NAMES } from "./auth.constants.ts";

/**
 * Infinite marquee. The track holds the list twice and translates by exactly
 * -50%, so the second copy lands where the first began and the loop is seamless
 * at any viewport width.
 */
export function TrustedByArtists() {
  return (
    <section className="trusted" aria-label="Trusted by artists">
      <div className="trusted__label">Trusted by artists</div>
      <div className="trusted__viewport">
        <div className="trusted__track">
          {/* First pass is the readable one; the duplicate exists only to fill
              the gap as the track scrolls, so it is hidden from assistive tech. */}
          <Names />
          <Names duplicate />
        </div>
      </div>
    </section>
  );
}

function Names({ duplicate = false }: { duplicate?: boolean }) {
  return (
    <ul className="trusted__group" aria-hidden={duplicate || undefined}>
      {TRUSTED_NAMES.map((name, index) => (
        <li className="trusted__item" key={`${name}-${index}`}>
          {name}
        </li>
      ))}
    </ul>
  );
}
